/**
 * columns: is columns for table.
 * dataSource: is data for render table, type array, every object in dataSource NEED UNIQUE KEY.
 * rowSelection: render checkbox per row, selected record.
 * isLoading: render loading when API fetching.
 * expandable: row collapse, render columns expand
 * scroll: take value FALSE | UNDEFINED, with value === false, turn off scroll bar
 */
import { InboxOutlined } from '@ant-design/icons';
import { Empty } from 'antd';
import { TableStyled2 } from 'components/AntdTable2/styled';
import useMultiLanguageCompanyList from 'page/Application/ManageCompanyList/CompanyList/hook/useMultiLanguageCompanyList';
import React, { useRef } from 'react';

const AntdTable2 = ({
  columns,
  dataSource,
  rowSelection,
  isLoading,
  expandable,
  // scroll,
  emptyText,
  onChange,
  height,
}) => {
  const { COMPANY_LIST_NO_DATA } = useMultiLanguageCompanyList();
  const tableRef = useRef();
  const CustomEmptyText = () => {
    return (
      <Empty
        image={<InboxOutlined />}
        styles={{ image: { fontSize: 80 } }}
        description={null}
        style={{ fontSize: '16px' }}
      >
        {emptyText || COMPANY_LIST_NO_DATA}
      </Empty>
    );
  };
  return (
    <TableStyled2
      style={{ minHeight: height }} // set min height for list table when data null or data length < 10
      ref={tableRef}
      columns={columns}
      rowSelection={rowSelection}
      // scroll={
      //   dataSource?.length > 8 ? scroll ?? { y: `calc(100dvh - 468px` } : 0
      // }
      expandable={expandable}
      dataSource={dataSource}
      pagination={false}
      showSizeChanger={true}
      onChange={onChange}
      loading={isLoading}
      locale={{ emptyText: CustomEmptyText }}
    />
  );
};

export default AntdTable2;
